module.exports = __webpack_public_path__ + "static/media/share.d8d30fb1.png";